<!-- eslint-disable semi -->
<template>
  <div style="padding-left: 3%; padding-right: 3%; background-color: #F8F9FA;">
    <!-- <Title /> -->
    <OverlayLoading :loading="loading" />
    <v-row class="mb-2">
      <v-col cols="6">
        <img
          width="10"
          height="14"
          src="@/assets/icons/back.png"
          class="mt-5 ml-0"
          style="cursor: pointer;"
          @click="goback"
        />
        <span class="header-title ml-0">
          เพิ่มพนักงาน
        </span>
      </v-col>
      <v-col
        cols="6"
        class="pt-0 pb-0 d-flex align-center justify-end mt-4 action-top-btn"
      >
        <v-btn
          class="button-color-outline ma-0"
          outlined
          dark
          @click="cancel()"
          >ยกเลิก</v-btn
        >
        <!-- <v-btn width="18%" class="ma-2 mr-5" color="#3776E9" dark @click="submitData()">บันทึกข้อมูล</v-btn> -->
        <v-btn
          v-if="accountId === '' && duplicate === true"
          class="ma-2 mr-5"
          color="grey"
          depressed
          disabled
          >บันทึกข้อมูล</v-btn
        >
        <v-btn
          v-else
          class="button-color ma-2 mr-5"
          dark
          @click="checkSubmit()"
          >บันทึกข้อมูล</v-btn
        >
      </v-col>
    </v-row>
    <!-- ค้นหาพนักงาน -->
    <v-row class="rounded-lg" style="background-color: #fff;" justify="center">
      <v-col cols="12" sm="12" md="6" lg="6">
        <div
          class="pt-0 d-flex flex-row align-center justify-end"
          color="grey lighten-2"
          flat
          tile
        >
          <span class="ra-span-text-highlight mb-4 mr-2">ค้นหาพนักงาน: </span>
          <v-text-field
            class="mt-0"
            placeholder="ค้นหาได้จาก Email One ID"
            v-model="keySearchEmployee"
            v-on:keyup.enter="searchEmployee(keySearchEmployee)"
            dense
            outlined
          >
            <template v-slot:append>
              <img
                width="18"
                height="18"
                src="@/assets/icons/search-icon-2.png"
                style="cursor: pointer;"
                @click="searchEmployee(keySearchEmployee)"
              />
            </template>
          </v-text-field>
          <v-tooltip bottom>
            <span class="label-table-action">ค้นหาพนักงาน</span>
          </v-tooltip>
        </div>
      </v-col>
    </v-row>
    <!-- ยังไม่มีข้อมูลพนักงาน -->
    <v-row
      v-if="accountId === ''"
      class="mt-2 rounded-lg"
      justify="center"
      fixed
      centered
      style="background-color: #fff; height: 750px;"
    >
      <v-col cols="8"> </v-col>
      <v-col cols="8" class="text-center mt-12" style="margin-top: 5%;">
        <img
          width="150"
          height="110"
          src="@/assets/icons/create-employee.png"
        />
        <p class="" style="font-weight: bold;">ยังไม่มีข้อมูลพนักงาน</p>
        <p class="ra-head-text">ค้นหาพนักงานที่คุณต้องการเพิ่ม</p>
      </v-col>
      <v-col
        cols="8"
        class="pt-0 pb-0 d-flex align-center justify-center mt-4"
        style="margin-top: -1%;"
      >
      </v-col>
      <div
        class="pt-0 d-flex flex-row align-center justify-end"
        color="grey lighten-2"
        flat
        tile
      ></div>
    </v-row>
    <!-- ข้อมูลส่วนตัว -->
    <v-row
      v-else
      class="mt-2 rounded-lg"
      justify="center"
      fixed
      centered
      style="background-color: #fff;"
    >
      <v-expansion-panels accordion v-model="panel" multiple>
        <v-row>
          <v-col cols="12">
            <v-card elevation="0" style="border-radius: 24px;">
              <v-card-title
                class="text-head-back ra-head-text-bold"
                style="font-size: 16px;"
                >ข้อมูลส่วนตัว</v-card-title
              >
              <v-card-subtitle>
                <v-row no-gutters class="mt-3">
                  <v-col cols="12" sm="4" md="4" lg="4"
                    class="d-flex flex-column align-center justify-center mt-5 mb-5"
                  >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-bind="attrs"
                          v-on="on"
                          class="box-employeeimg ml-0 "
                          @click="ChooseBanner()"
                          style="max-height: 100%; max-width: 75%; background-size: contain;"
                        >
                          <div class="pa-0 box-placeholderimg">
                            <div
                              class="placeholderimg"
                              :style="{
                                'background-image': `url(${imageUrl})`
                              }"
                            >
                              <v-img
                                v-if="!imageUrl"
                                width="100"
                                height="100"
                                contain
                                :src="require('@/assets/icons/no_user.png')"
                                aspect-ratio="1"
                              />
                              <input
                                class="file-input"
                                id="files"
                                ref="Pickfiles"
                                type="file"
                                accept="image/*"
                                v-on:change="onBannerSelected()"
                              />
                            </div>
                          </div>
                        </div>
                      </template>
                      <span class="" v-if="imageUrl"
                        >คลิกเพื่อเลือกรูปใหม่</span
                      >
                      <span class="" v-if="!imageUrl">คลิกเพื่อเลือกรูป</span>
                    </v-tooltip>
                    <span class="label-codeid txt-font mt-5"
                      >รูปภาพประจำตัว</span
                    >
                  </v-col>
                  <v-col cols="12" sm="8" md="8" lg="8" class="mt-5">
                    <v-row>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <p class="txt-font">ชื่อ-นามสกุล (ภาษาไทย)</p>
                      <span class="txt-font" style="color: #333;">{{ fnameTH || "-" }} {{ lnameTH }}</span>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <p class="txt-font">ชื่อ-นามสกุล (ภาษาอังกฤษ)</p>
                          <span class="txt-font" style="color: #333;">{{ fnameEN || "-" }} {{ lnameEN }}</span>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <p class="txt-font">วันเกิด</p>
                          <span class="txt-font" style="color: #333;">{{birthDate || "-"}}</span>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <p class="txt-font">อีเมล</p>
                          <span class="txt-font" style="color: #333;">{{email || "-"}}</span>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <p class="txt-font">เบอร์โทรศัพท์</p>
                          <span class="txt-font" style="color: #333;">{{tel || "-"}}</span>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6">
                        <p class="txt-font">Account ID</p>
                          <span class="txt-font" style="color: #333;">{{accountId || "-"}}</span>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card-subtitle>
            </v-card>
            <v-divider class="ml-5 mr-5"></v-divider>
          </v-col>
          <v-col cols="12">
            <v-card elevation="0" style="border-radius: 24px;">
              <v-card-title
                class="text-head-back ra-head-text-bold"
                style="font-size: 16px;">
                ข้อมูลพนักงาน
                <span class="txt-head">
                  <span class="ml-1"></span>
                    <span class="txt-font" style="color: grey; font-size: 14px;">(&nbsp;</span>
                      <span style="color: red;">*</span>
                        <span class="txt-font" style="color: grey; font-size: 14px;">กรอกข้อมูลให้ครบถ้วน)</span>
                </span>
              </v-card-title
              >
              <v-card-subtitle>
                <v-row class="mb-2">
                  <v-col
                    cols="12"
                    class="pt-0 d-flex flex-row align-center justify-end"
                  >
                    <v-btn
                      outlined
                      color="#fff"
                      dark
                      class=""
                      v-scroll-to="{ el: '#element', duration: 1500}"
                      @click="addEmployee()"
                    >
                      <v-icon left dark class="icon-eye-color" size="14px"
                        >fa-plus</v-icon
                      >
                      <span
                        class="text-sub-color ra-text-in-button-employee fw-bold"
                        style="font-weight: 600;"
                      >
                        เพิ่มข้อมูลพนักงาน
                      </span>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-card
                  elevation="0"
                  class="mx-auto px-3 mb-5"
                  style="border: 2px solid #EEEEEE;"
                  v-for="(item, i) in dataEmployee"
                  :key="i"
                  :id="i+1 === dataEmployee.length ? 'element' : undefined"
                >
                  <div>
                    <v-row style="background-color:#EFF4FD">
                      <v-col cols="10">
                        <v-col
                          cols="10"
                          class="pt-0 pa-2 d-flex flex-row justify-start"
                        >
                          <span class="txt-head"
                            >ลำดับที่ {{ i + 1 }}<span class="ml-1"></span
                            ><span
                              class="txt-font"
                              style="color: grey; font-size: 14px;"
                              >&nbsp;(</span
                            ><span style="color: red;">*</span
                            ><span
                              class="txt-font"
                              style="color: grey; font-size: 14px;"
                              >กรอกข้อมูลให้ครบถ้วน)</span
                            ></span
                          >
                        </v-col>
                      </v-col>
                      <v-col
                        v-if="i !== 0"
                        cols="2"
                        class="pt-0 pa-2 d-flex flex-row align-center justify-end"
                      >
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              dark
                              icon
                              tile
                              class="ra-border-button mr-2"
                              @click="checkRemoveEmployee(item)"
                            >
                              <template v-slot>
                                <v-icon dark color="#D1392B" size="19px"
                                  >mdi-delete-outline</v-icon
                                >
                              </template>
                            </v-btn>
                          </template>
                          <span class="label-table-action">ลบข้อมูล</span>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-row class="pl-5 pr-5 mb-4">
                      <v-col cols="12" class="mt-3">
                        <span class="txt-head">ประเภทพนักงาน</span>
                        <span style="color: red;"> *</span>
                      </v-col>
                      <v-col cols="12" sm="12" md="4" lg="4">
                        <v-radio-group
                          v-model="dataEmployee[i].employeeType"
                          row
                        >
                        <v-row>
                          <v-col cols="6">
                            <v-radio
                              color="#2BA197"
                              class="mb-2"
                              label="พนักงานภายใน"
                              value="พนักงานภายใน"
                            ></v-radio>
                            <v-radio
                              color="#2BA197"
                              label="ที่ปรึกษา"
                              value="ที่ปรึกษา"
                            ></v-radio>
                          </v-col>
                          <v-col cols="6">
                            <v-radio
                              class="mb-2"
                              color="#2BA197"
                              label="พนักงานภายนอก"
                              value="พนักงานภายนอก"
                            ></v-radio>
                            <v-radio
                              color="#2BA197"
                              label="นักศึกษาฝึกงาน"
                              value="นักศึกษาฝึกงาน"
                            ></v-radio>
                          </v-col>
                        </v-row>
                        </v-radio-group>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="4" class="mt-n5">
                        <span>ต้นสังกัด</span
                        ><span style="color: red;"> *</span>
                        <v-autocomplete
                          dense
                          v-model="dataEmployee[i].parentCompanyText"
                          :items="['บริษัทหลัก', 'บริษัทรอง']"
                          placeholder="เลือกต้นสังกัด"
                          @change="
                            setParentCompany(
                              i,
                              dataEmployee[i].parentCompanyText
                            )
                          "
                          outlined
                          :rules="rulesCompany"
                        ></v-autocomplete>
                      </v-col>
                      <v-col cols="12" sm="6" md="4" lg="4" class="mt-n5">
                        <span>ศูนย์</span>
                        <v-autocomplete
                          dense
                          v-model="dataEmployee[i].station"
                          :items="stationList"
                          item-text="stationName"
                          item-value="stationName"
                          placeholder="เลือกศูนย์"
                          outlined
                          :rules="rulesStation"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="dataEmployee[i].employeeType !== ''"
                      class="ml-2 mr-2"
                      style="margin-bottom: -5px;"
                    >
                    <!-- บริษัท -->
                      <v-col cols="12" sm="6" md="4" lg="4" class="mt-n5">
                        <span>บริษัท</span><span style="color: red;"> *</span>
                        <v-autocomplete
                          dense
                          v-model="dataEmployee[i].companyId"
                          :items="dataEmployee[i].companyItems"
                          placeholder="เลือกบริษัท"
                          item-text="companyFullNameTh"
                          item-value="_id"
                          @change="
                            getSelectLineofworkDetail(i, dataEmployee[i].companyId)
                          "
                          outlined
                          :rules="rulesCompany"
                          @keyup="getSelectCompany(i, $event.target.value)"
                        ></v-autocomplete>
                      </v-col>
                      <!-- รหัสพนักงาน -->
                      <v-col cols="12" sm="6" md="4" lg="4" class="mt-n5">
                        <span>รหัสพนักงาน</span
                        ><span style="color: red;"> *</span>
                        <v-text-field
                          v-model="dataEmployee[i].employeeId"
                          :rules="rulesEmployeeId"
                          dense
                          outlined
                          :readonly="dataEmployee[i].companyId === ''"
                          placeholder="ระบุรหัสพนักงาน"
                          @keydown.space.prevent
                        ></v-text-field>
                      </v-col>
                      <!-- รูปแบบพนักงาน -->
                      <v-col cols="12" sm="6" md="4" lg="4" class="mt-n5">
                        <span>รูปแบบพนักงาน</span>
                        <v-autocomplete
                          dense
                          v-model="dataEmployee[i].contractType"
                          :items="employeeTypeList"
                          item-text="type"
                          item-value="type"
                          placeholder="เลือกรูปแบบพนักงาน"
                          outlined
                        >
                          <template v-slot:selection="{ item }">
                            {{ item.type }}
                          </template>
                          <template v-slot:item="{ item }">
                            {{`${item.type} (${item.typeEng})`,}}
                          </template>
                        </v-autocomplete>
                      </v-col>
                      <!-- วันที่เริ่มงาน -->
                      <v-col cols="12" sm="6" md="4" lg="4" class="mt-n5">
                        <span>วันที่เริ่มงาน</span
                        ><span style="color: red;"> *</span>
                        <v-menu
                          v-model="dataEmployee[i].menu"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          full-width
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="dataEmployee[i].startWorkDate"
                              placeholder="เลือกวันที่เริ่มทำงาน"
                              persistent-hint
                              readonly
                              v-on="on"
                              outlined
                              dense
                            >
                              <template v-slot:append>
                                <v-icon class="icon-eye-color">mdi-calendar</v-icon>
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="dataEmployee[i].startWorkDate"
                            no-title
                            @input="dataEmployee[i].menu = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <!-- วันที่สิ้นสุด(ไม่จำเป็น) -->
                      <v-col cols="12" sm="6" md="4" lg="4" class="mt-n5"
                        v-if="dataEmployee[i].employeeType === 'พนักงานภายนอก'"
                      >
                        <span>วันที่สิ้นสุด(ไม่จำเป็น)</span>
                        <v-menu
                          v-model="dataEmployee[i].menu2"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          full-width
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="dataEmployee[i].endWorkDate"
                              placeholder="เลือกวันที่สิ้นสุด"
                              persistent-hint
                              readonly
                              v-on="on"
                              outlined
                              dense
                            >
                              <template v-slot:append>
                                <img
                                  width="20"
                                  height="20"
                                  src="@/assets/icons/today.png"
                                />
                              </template>
                            </v-text-field>
                          </template>
                          <v-date-picker
                            v-model="dataEmployee[i].endWorkDate"
                            no-title
                            @input="dataEmployee[i].menu2 = false"
                          ></v-date-picker>
                        </v-menu>
                      </v-col>
                      <!-- รวม 5 สายงาน -->
                       <v-col cols="12" sm="6" md="4" lg="4" class="mt-n5">
                        <span>แผนก</span
                        ><span
                          style="color: red;"
                        >
                          *</span
                        >
                        <v-autocomplete
                          dense
                          v-model="dataEmployee[i].orgchart"
                          :items="dataEmployee[i].departmentsItems"
                          placeholder="เลือกแผนก"
                          item-text="orgChartName"
                          item-value="_id"
                          outlined
                          :disabled="dataEmployee[i].companyId === ''"
                          :rules="dataEmployee[i].rulesLineofworks"
                          @keyup="getSelect($event.target.value, 'แผนก',i,dataEmployee[i].companyId)"
                        ></v-autocomplete>
                      </v-col>
                      <!-- สายงาน -->
                      <!-- <v-col cols="12" sm="6" md="4" lg="4" class="mt-n5">
                        <span>สายงาน</span
                        ><span
                          v-if="dataEmployee[i].lineofworkStatus === true"
                          style="color: red;"
                        >
                          *</span
                        >
                        <v-select
                          dense
                          v-model="dataEmployee[i].lineofworkId"
                          :items="dataEmployee[i].lineofworkItems"
                          placeholder="เลือกสายงาน"
                          item-text="orgChartName"
                          item-value="_id"
                          outlined
                          :disabled="dataEmployee[i].lineofworkStatus === false"
                          :rules="dataEmployee[i].rulesLineofworks"
                          @change="
                            getDataListOrgChart(
                              i,
                              dataEmployee[i].lineofworkId,
                              dataEmployee[i].companyId,
                              'สายงาน'
                            )
                          "
                        ></v-select>
                      </v-col> -->
                      <!-- ฝ่ายงาน -->
                      <!-- <v-col cols="12" sm="6" md="4" lg="4" class="mt-n5">
                        <span>ฝ่ายงาน</span
                        ><span
                          v-if="dataEmployee[i].departmentStatus === true"
                          style="color: red;"
                        >
                          *</span
                        >
                        <v-select
                          dense
                          v-model="dataEmployee[i].departmentId"
                          :items="dataEmployee[i].departmentsItems"
                          placeholder="เลือกฝ่ายงาน"
                          item-text="orgChartName"
                          item-value="_id"
                          outlined
                          :disabled="dataEmployee[i].departmentStatus === false"
                          :rules="dataEmployee[i].rulesDepartment"
                          @change="
                            getDataListOrgChart(
                              i,
                              dataEmployee[i].departmentId,
                              dataEmployee[i].companyId,
                              'ฝ่ายงาน'
                            )
                          "
                        ></v-select>
                      </v-col> -->
                      <!-- ส่วนงาน -->
                      <!-- <v-col cols="12" sm="6" md="4" lg="4" class="mt-n5">
                        <span>ส่วนงาน</span
                        ><span
                          v-if="dataEmployee[i].sectionStatus === true"
                          style="color: red;"
                        >
                          *</span
                        >
                        <v-select
                          dense
                          v-model="dataEmployee[i].sectionId"
                          :items="dataEmployee[i].sectionItems"
                          placeholder="เลือกส่วนงาน"
                          item-text="orgChartName"
                          item-value="_id"
                          outlined
                          :disabled="dataEmployee[i].sectionStatus === false"
                          :rules="dataEmployee[i].rulesSection"
                          @change="
                            getDataListOrgChart(
                              i,
                              dataEmployee[i].sectionId,
                              dataEmployee[i].companyId,
                              'ส่วนงาน'
                            )
                          "
                        ></v-select>
                      </v-col> -->
                      <!-- หน่วยงาน -->
                      <!-- <v-col cols="12" sm="6" md="4" lg="4" class="mt-n5">
                        <span>หน่วยงาน</span
                        ><span
                          v-if="dataEmployee[i].agencyStatus === true"
                          style="color: red;"
                        >
                          *</span
                        >
                        <v-select
                          dense
                          v-model="dataEmployee[i].agencyId"
                          :items="dataEmployee[i].agencyItems"
                          placeholder="เลือกหน่วยงาน"
                          item-text="orgChartName"
                          item-value="_id"
                          outlined
                          :disabled="dataEmployee[i].agencyStatus === false"
                          :rules="dataEmployee[i].rulesAgency"
                          @change="
                            getDataListOrgChart(
                              i,
                              dataEmployee[i].agencyId,
                              dataEmployee[i].companyId,
                              'หน่วยงาน'
                            )
                          "
                        ></v-select>
                      </v-col> -->
                      <!-- กลุ่มงาน -->
                      <!-- <v-col cols="12" sm="6" md="4" lg="4" class="mt-n5">
                        <span>กลุ่มงาน</span
                        ><span
                          v-if="dataEmployee[i].groupStatus === true"
                          style="color: red;"
                        >
                          *</span
                        >
                        <v-select
                          dense
                          v-model="dataEmployee[i].groupId"
                          :items="dataEmployee[i].groupItems"
                          placeholder="เลือกประเภท"
                          item-text="orgChartName"
                          item-value="_id"
                          outlined
                          :disabled="dataEmployee[i].groupStatus === false"
                          :rules="dataEmployee[i].rulesGroup"
                          @change="
                            getDataListOrgChart(
                              i,
                              dataEmployee[i].groupId,
                              dataEmployee[i].companyId,
                              'กลุ่มงาน'
                            )
                          "
                        ></v-select>
                      </v-col> -->
                      <!-- ตำแหน่ง -->
                      <v-col cols="12" sm="6" md="4" lg="4" class="mt-n5">
                        <v-row
                          :style="
                            $vuetify.breakpoint.name !== 'lg'
                              ? 'margin-top: -3.0%;'
                              : 'margin-top: -3.0%;'
                          "
                        >
                          <span class="ml-3 mt-5">ตำแหน่งงาน</span
                          ><span
                            class="ml-1 mt-5"
                            v-if="dataEmployee[i].companyId !== ''"
                            style="color: red;"
                          >
                            *</span
                          >
                          <v-spacer></v-spacer>
                          <v-btn
                            outlined
                            color="#fff"
                            dark
                            class="my-2"
                            style="margin-top: 0%;"
                            @click="
                              openDialogAddPosition(
                                dataEmployee[i].companyId,
                                i
                              )
                            "
                          >
                            <v-icon left dark class="icon-eye-color" size="14px"
                              >fa-plus</v-icon
                            >
                            <span
                              class="text-sub-color ra-text-in-button-employee"
                              style="font-weight: 600;"
                            >
                              เพิ่มตำแหน่งงาน
                            </span>
                          </v-btn>
                        </v-row>
                        <v-autocomplete
                          style="margin-top: -2%;"
                          dense
                          v-model="dataEmployee[i].positionId"
                          :items="dataEmployee[i].positionItems"
                          placeholder="เลือกตำแหน่ง"
                          item-text="positionName"
                          item-value="_id"
                          outlined
                          :rules="dataEmployee[i].rulesPosition"
                          @keyup="getSelect($event.target.value, 'ตำแหน่ง',i,dataEmployee[i].companyId)"
                        ></v-autocomplete>
                      </v-col>
                    </v-row>
                    <div
                      v-if="dataEmployee[i].employeeType !== ''"
                      class="d-flex flex-column mt-2 px-7"
                      style="width: 100%;"
                    >
                      <v-row>
                        <v-col cols="12">
                          <v-divider></v-divider>
                        </v-col>
                      </v-row>
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <div class="manage-department-title">
                          การอนุมัติ
                        </div>
                      </v-col>
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <div class="d-flex flex-row">
                          <span
                            class="txt-font mr-4 mt-2"
                            style="margin-top: 0px;"
                            >ต้องการให้หัวหน้าอนุมัติ</span
                          >
                          <v-switch
                            class="mt-0"
                            style="margin-top: 0%;"
                            v-model="dataEmployee[i].chkLeaderApprove"
                            :label="`${dataEmployee[i].leaderApprove}`"
                            color="#2BA197"
                            :disabled="chkDisable === true"
                            @change="
                              setOpenApprover(
                                i,
                                dataEmployee[i].chkLeaderApprove,
                                dataEmployee[i].departmentId
                              )
                            "
                          ></v-switch>
                          <v-divider
                            v-if="dataEmployee[i].chkLeaderApprove === true"
                            class="ml-5"
                            vertical
                          ></v-divider>
                          <v-btn
                            v-if="dataEmployee[i].chkLeaderApprove === true"
                            outlined
                            right
                            color="#fff"
                            dark
                            class="mr-2 ml-3 mb-0 pa-1 align-center"
                            style="margin-top: -1%;"
                            @click="openDialogAddAprover('add', '', i)"
                          >
                            <v-icon left dark class="icon-eye-color">fa-plus</v-icon>
                            <span class="text-sub-color txt-font"
                              >เพิ่มผู้อนุมัติ/รับทราบ</span
                            >
                          </v-btn>
                        </div>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                        lg="12"
                        v-for="(itemJ, j) in dataEmployee[i].approver"
                        :key="j"
                      >
                        <v-expand-transition>
                          <v-card
                            v-show="dataEmployee[i].expand"
                            class="elevation-0 mx-auto px-3"
                            style="background-color: #FAFAFA; border-radius: 4px; border: 2px solid #EEEEEE;"
                          >
                            <v-row style="background-color:#EFF4FD;">
                              <v-col
                                cols="10"
                                class="pt-0 pa-2 d-flex flex-row justify-start"
                              >
                                  <span
                                    class="ra-text-in-button-employee mt-2"
                                    style="color: #3776E9;"
                                  >
                                    ลำดับที่ {{ j + 1 }}
                                  </span>
                              </v-col>
                              <v-col
                                cols="2"
                                class="pt-0 pa-2 d-flex flex-row align-center justify-end"
                              >
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      v-bind="attrs"
                                      v-on="on"
                                      rounded
                                      small
                                      dark
                                      icon
                                      class="ra-border-button mt-2 mb-0"
                                      @click="
                                        openDialogAddAprover(
                                          'edit',
                                          itemJ,
                                          i,
                                          j
                                        )
                                      "
                                      >
                                      <template v-slot>
                                        <img
                                          width="18"
                                          height="18"
                                          src="@/assets/icons/edit-icon.png"
                                        />
                                      </template>
                                    </v-btn>
                                  </template>
                                  <span class="label-table-action"
                                    >จัดการผู้ดูแล</span
                                  >
                                </v-tooltip>
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ attrs }">
                                    <v-btn
                                      v-bind="attrs"
                                      rounded
                                      dark
                                      small
                                      icon
                                      class="ra-border-button mt-2 mb-0 ml-2"
                                      @click="checkRemove(itemJ, i)"
                                      >
                                      <template v-slot>
                                        <img
                                          width="18"
                                          height="18"
                                          src="@/assets/icons/delete-icon.png"
                                        />
                                      </template>
                                    </v-btn>
                                  </template>
                                  <span class="label-table-action"
                                    >ลบผู้ดูแล</span
                                  >
                                </v-tooltip>
                              </v-col>
                            </v-row>
                            <v-row no-gutters class="mt-3">
                              <v-col cols="1">
                                <v-avatar
                                  class="mt-3 ml-3"
                                  size="60"
                                  rounded
                                  style="float: left;"
                                >
                                  <v-img
                                    class="card-header-userimg-border"
                                    cover
                                    :lazy-src="
                                      require('@/assets/icons/no_user.png')
                                    "
                                    :src="
                                      itemJ.failed_image
                                        ? require('@/assets/icons/no_user.png')
                                        : itemJ.userImg
                                    "
                                    :alt="itemJ.employeeId"
                                    v-on:error="onImgError(i, j)"
                                    aspect-ratio="1"
                                    height="100%"
                                  />
                                </v-avatar>
                              </v-col>
                              <v-col cols="10" class="ml-8">
                                <v-row class="mr-3">
                                  <v-col
                                    cols="4"
                                    class="justify-start align-start"
                                  >
                                    <span
                                      class="txt-font"
                                      style="margin-top: 2.5%;"
                                      >รหัสพนักงาน:
                                    </span>
                                    <span
                                      class="txt-font text-left"
                                      style="color: #333; margin-top: 0%;"
                                      >{{ itemJ.employeeId || "-" }}
                                    </span>
                                  </v-col>
                                  <v-col
                                    cols="4"
                                    class="justify-start align-start"
                                  >
                                    <span
                                      class="txt-font"
                                      style="margin-top: 2.5%;"
                                      >ชื่อ-นามสกุล:
                                    </span>
                                    <span
                                      class="txt-font text-left"
                                      style="color: #333; margin-top: 0%;"
                                      >{{ itemJ.approverName || "-" }}</span
                                    >
                                  </v-col>
                                  <!-- <v-col
                                    cols="4"
                                    class="justify-start align-start"
                                  >
                                    <span
                                      class="txt-font"
                                      style="margin-top: 2.5%;"
                                      >ตำแหน่ง:
                                    </span>
                                    <span
                                      class="txt-font text-left"
                                      style="color: #333; margin-top: 0%;"
                                      >{{ itemJ.position || "-" }}
                                    </span>
                                  </v-col> -->
                                </v-row>
                                <v-row class="mr-3">
                                  <v-col
                                    cols="4"
                                    class="justify-start align-start"
                                  >
                                    <span
                                      class="txt-font"
                                      style="margin-top: 2.5%;"
                                      >อีเมล:
                                    </span>
                                    <span
                                      class="txt-font text-left"
                                      style="color: #333; margin-top: 0%;"
                                      >{{ itemJ.email || "-" }}
                                    </span>
                                  </v-col>
                                  <v-col
                                    cols="4"
                                    class="justify-start align-start"
                                  >
                                    <span
                                      class="txt-font"
                                      style="margin-top: 2.5%;"
                                      >สถานะ:
                                    </span>
                                    <span
                                      class="txt-font text-left"
                                      style="color: #333; margin-top: 0%;"
                                      >{{ itemJ.approveType || "-" }}
                                    </span>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                          </v-card>
                        </v-expand-transition>
                      </v-col>
                    </div>
                  </div>
                </v-card>
              </v-card-subtitle>
            </v-card>
          </v-col>
        </v-row>
      </v-expansion-panels>
    </v-row>
    <v-dialog v-model="dialogDelete" max-width="500px">
      <v-card height="170px">
        <v-card-title class="ra-head-text-bold justify-center pa-5"
          >ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title
        >
        <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center"
            >คุณแน่ใจหรือว่าต้องการลบข้อมูลนี้</span
          >
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn
            class="ra-button1"
            color="#2BA197"
            outlined
            @click="dialogDelete = false"
            >ยกเลิก</v-btn
          >
          <v-btn
            class="ra-button1"
            color="#2BA197"
            dark
            @click="removeEmployee(itemConfirmDelete)"
            >ลบข้อมูล</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogDeleteApprover" max-width="500px">
      <v-card height="170px">
        <v-card-title class="ra-head-text-bold justify-center pa-5"
          >ต้องการลบข้อมูลนี้ ใช่หรือไม่?</v-card-title
        >
        <v-card-text class="justify-center text-center">
          <span class="ra-head-text justify-center"
            >คุณแน่ใจหรือว่าต้องการลบข้อมูลผู้อนุมัติคนนี้</span
          >
        </v-card-text>
        <v-card-actions class="">
          <v-spacer></v-spacer>
          <v-btn
            class="ra-button1"
            color="#2BA197"
            outlined
            @click="dialogDeleteApprover = false"
            >ยกเลิก</v-btn
          >
          <v-btn
            class="ra-button1"
            color="#2BA197"
            dark
            @click="removeApprover(itemConfirmDelete, itemIdex)"
            >ลบข้อมูล</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="text-center">
      <v-row>
        <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          text
          top
          app
        >
          <v-icon left dark small :color="snackbarColor"
            >fa-check-circle</v-icon
          >
          <span :style="{ color: `${snackbarColor}` }">{{ text }}</span>
        </v-snackbar>
      </v-row>
    </div>
    <DialogAddAprover />
    <DialogAddPosition />
  </div>
</template>

<script>
import OverlayLoading from '../../_template/OverlayLoading.vue'
import { EventBus } from '@/EventBus'
import swal from 'sweetalert'
import {
  hostImageUrlv3,
  searchSelectEmployee,
  getSelectCompanyEmployeeNew,
  insertEmployee, // บันทึกข้อมูล
  getDefaultApprover,
  SelectDataCenterinEditOfficer
} from '@/API/API'
import DialogAddAprover from './dialogAddApprover'
import DialogAddPosition from './dialogAddPosition'
import moment from 'moment'
moment.locale('th')

export default {
  components: {
    OverlayLoading,
    DialogAddAprover,
    DialogAddPosition
  },
  name: 'create-new-employee',
  data () {
    return {
      multiLine: true,
      snackbar: false,
      timeout: 2000,
      snackbarColor: '',
      text: '',
      dialogDelete: false,
      dialogDeleteApprover: false,
      titleDialog: '',
      itemConfirmDelete: [],
      itemIdex: 0,
      panel: [0, 0],
      employeeType: null,
      activeTab: 1,
      loading: false,
      loadingProfileData: false,
      loadingEmployeeData: false,
      keySearchEmployee: [],
      date: new Date().toISOString().substr(0, 10),
      rulesSearch: [v => !!v || 'กรุณากรอก Username หรือ E-mail'],
      imgUser: null,
      imageUrl: null,
      failed_imageEmployee: false,
      imagePathUrl: null,
      genderth_radios: null,
      genderen_radios: null,
      itemDefault: [
        {
          orgChartName: 'ไม่มี',
          pid: null,
          _id: 'ไม่มี'
        }
      ],
      genderthlists: [
        {
          id: 0,
          nameTH: 'นาย',
          nameEN: 'Mr.',
          value: 'Mr.'
        },
        {
          id: 1,
          nameTH: 'นาง',
          nameEN: 'Mrs.',
          value: 'Mrs.'
        },
        {
          id: 2,
          nameTH: 'นางสาว',
          nameEN: 'Ms.',
          value: 'Miss'
        }
      ],
      fnameTH: '',
      lnameTH: '',
      fnameEN: '',
      lnameEN: '',
      accountId: '',
      duplicate: true,
      birthDate: moment(new Date().toISOString().substr(0, 10)).format(
        'DD/MM/YYYY'
      ),
      email: '',
      companyId: '',
      userId: '',
      companyItems: [], // ตัวเลือกบริษัท
      departmentsItems: [], // ตัวเลือกรงมทุกแผนก
      stationList: [], // ตัวเลือกศูนย์
      employeeTypeList: [], // ตัวเลือกรูปแบบพนักงาน
      rulesStation: [v => !!v || 'กรุณาเลือกศูนย์'],
      rulesCompany: [v => !!v || 'กรุณาเลือกบริษัท'],
      employeeId: '',
      rulesEmployeeId: [v => !!v || 'กรุณากรอกรหัสพนักงาน'],
      lineofworkId: '',
      lineofworkItems: [], // ตัวเลือกสายงาน
      rulesLineofworks: [v => !!v || 'กรุณาเลือกประเภท'],
      departmentId: '',
      rulesDepartment: [v => !!v || 'กรุณาเลือกฝ่ายงาน'],
      positionId: '',
      positionItems: [], // ตัวเลือกตำแหน่ง
      rulesPosition: [v => !!v || 'กรุณาเลือกตำแหน่ง'],
      // startWorkDate: moment(new Date().toISOString().substr(0, 10)).format('DD/MM/YYYY'),
      startWorkDate: new Date().toISOString().substr(0, 10),
      endWorkDate: new Date().toISOString().substr(0, 10),
      rulesDateStart: [v => !!v || 'กรุณาเลือกวันที่เริ่มงาน'],
      rulesDateEnd: [v => !!v || 'กรุณาเลือกวันที่สิ้นสุด'],
      chkDisable: false,
      menu: false,
      menu2: false,
      dataEmployee: [
        {
          employeeType: '',
          parentCompanyText: 'บริษัทหลัก',
          companyId: '',
          expand: false,
          menu: false,
          menu2: false,
          orgchart: '', // ส่ง id ไป
          startWorkDate: new Date().toISOString().substr(0, 10),
          endWorkDate: new Date().toISOString().substr(0, 10),
          rulesCompany: [v => !!v || 'กรุณาเลือกบริษัท'],
          lineofworkStatus: false, // สายงาน
          lineofworkDisable: false,
          lineofworkId: '',
          lineofworkItems: [],
          rulesLineofworks: [v => !!v || 'กรุณาเลือกประเภท'],
          departmentStatus: false,
          departmentDisable: false,
          departmentId: '',
          departmentsItems: [],
          rulesDepartment: [v => !!v || 'กรุณาเลือกฝ่ายงาน'],
          sectionStatus: false,
          sectionDisable: false,
          sectionId: '',
          sectionItems: [], // ตัวเลือกส่วนงาน
          rulesSection: [v => !!v || 'กรุณาเลือกส่วนงาน'],
          groupStatus: false,
          groupDisable: false,
          groupId: '',
          groupItems: [], // ตัวเลือกประเภท
          rulesGroup: [v => !!v || 'กรุณาเลือกกลุ่มงาน'],
          agencyStatus: false,
          agencyDisable: false,
          agencyId: '',
          agencyItems: [], // ตัวเลือกหน่วยงาน
          rulesAgency: [v => !!v || 'กรุณาเลือกหน่วยงาน'],
          positionStatus: false,
          positionDisable: true,
          positionId: '',
          positionItems: [],
          rulesPosition: [v => !!v || 'กรุณาเลือกตำแหน่ง'],
          employeeId: '',
          employee_id: '',
          chkLeaderApprove: false,
          leaderApprove: 'ไม่ต้องการ',
          chkEmployeeResign: false,
          EmployeeResign: 'ไม่ต้องการ',
          approver: [],
          companyItems: [] // ตัวเลือกบริษัท
        }
      ],
      // approver: [
      //   {
      //     no: 1,
      //     _id: '1212xx',
      //     employeeId: 'sittikorn0993',
      //     approverName: 'นายสมพงษ์ อิอิ',
      //     position: 'ตำแหน่ง xxxx',
      //     email: 'kookkai@one.th',
      //     userImg: 'https://picsum.photos/200',
      //     failed_image: true
      //   }
      // ],
      alertText: {
        'employeeId is already': 'รหัสพนักงานซ้ำ',
        'user is already': 'มีพนักงานคนนี้ในระบบแล้ว',
        'employee not found': 'ไม่พบพนักงาน',
        'employee is resign': 'พนักงานลาออกไปแล้ว',
        'orgChart not found': 'ไม่พบฝ่ายงาน',
        // 'request is already': 'ใบคำขออยู่ระหว่างดำเนินการ',
        'request is already': 'มีคำร้องนี้ในระบบแล้ว',
        'data incomplete': 'กรุณากรอกข้อมูลให้ครบถ้วน'
      },
      alertTextDetail: {
        'user is already': 'กรุณาลองใหม่อีกครั้ง',
        'employeeId is already': 'กรุณาลองใหม่อีกครั้ง',
        'chart not found': 'กรุณาลองใหม่อีกครั้ง',
        'user not found': 'กรุณาลองใหม่อีกครั้ง',
        'request is already': 'กรุณาอนุมัติคำร้องที่มีอยู่ในระบบ'
      },
      expand: false,
      headers: [
        {
          text: 'ลำดับ',
          align: 'start',
          sortable: false,
          value: 'no'
        },
        { text: 'รูป', value: 'userImg' },
        { text: 'รหัสพนักงาน', value: 'employeeId' },
        { text: 'ชื่อ-นามสกุล', value: 'approverName' },
        { text: 'ตำแหน่ง', value: 'position' },
        { text: 'อีเมล', value: 'email' },
        { text: 'จัดการ', value: 'actions', sortable: false }
      ]
    }
  },
  mounted () {
    EventBus.$on('addAprover', this.add)
    EventBus.$on('addPosition', this.addPosition)
  },
  beforeDestroy () {
    EventBus.$off('addAprover')
    EventBus.$off('addPosition')
  },
  async created () {
    // console.log(this.$store.state.token)
    if (!this.$store.state.token) {
      this.goLogin()
    } else {
      await this.getSelectCompany()
      await this.getCenterManageEmployee()
    }
  },
  computed: {
    checkCompany () {
      return !!this.selectGroupCompany.length
    }
  },
  watch: {
    chkEmployeeResign (value) {
      // console.log(value)
      if (value === true) {
        this.EmployeeResign = 'ต้องการ'
        this.expand = true
      } else {
        this.EmployeeResign = 'ไม่ต้องการ'
        this.expand = false
        // this.approver = []
      }
    }
  },
  methods: {
    setOpenApprover (i, value, departmentId) {
      if (value === true) {
        this.dataEmployee[i].leaderApprove = 'ต้องการ'
        this.dataEmployee[i].expand = true
        // this.expand = true
        this.setApprover(i, departmentId)
      } else {
        this.dataEmployee[i].leaderApprove = 'ไม่ต้องการ'
        this.dataEmployee[i].expand = false
        // this.expand = false
        this.dataEmployee[i].approver = []
      }
    },
    setParentCompany (indexI, item) {
      this.dataEmployee.filter(r => {
        if (r.parentCompanyText === 'บริษัทหลัก') {
          return r
        }
      })
      // if (findParentCompany.length >= 0) {
      //   for (let index = 0; index < this.dataEmployee.length; index++) {
      //     this.dataEmployee[index].parentCompanyText = 'บริษัทรอง'
      //     console.log(this.dataEmployee[index].parentCompanyText)
      //   }
      //   this.dataEmployee[indexI].parentCompanyText = 'บริษัทหลัก'
      // }
    },
    async searchEmployee (value) {
      this.loading = true
      this.dataEmployee = []
      this.dataEmployee.push({
        employeeType: '',
        parentCompanyText: 'บริษัทหลัก',
        companyId: '',
        expand: false,
        menu: false,
        menu2: false,
        startWorkDate: new Date().toISOString().substr(0, 10),
        endWorkDate: new Date().toISOString().substr(0, 10),
        rulesCompany: [v => !!v || 'กรุณาเลือกบริษัท'],
        lineofworkStatus: false,
        lineofworkDisable: false,
        lineofworkId: '',
        lineofworkItems: [],
        rulesLineofworks: [v => !!v || 'กรุณาเลือกประเภท'],
        departmentStatus: false,
        departmentDisable: false,
        departmentId: '',
        departmentsItems: [],
        rulesDepartment: [v => !!v || 'กรุณาเลือกฝ่ายงาน'],
        sectionStatus: false,
        sectionDisable: false,
        sectionId: '',
        sectionItems: [],
        rulesSection: [v => !!v || 'กรุณาเลือกส่วนงาน'],
        groupStatus: false,
        groupDisable: false,
        groupId: '',
        groupItems: [],
        rulesGroup: [v => !!v || 'กรุณาเลือกกลุ่มงาน'],
        agencyStatus: false,
        agencyDisable: false,
        agencyId: '',
        agencyItems: [],
        rulesAgency: [v => !!v || 'กรุณาเลือกหน่วยงาน'],
        positionStatus: false,
        positionDisable: true,
        positionId: '',
        positionItems: [],
        rulesPosition: [v => !!v || 'กรุณาเลือกตำแหน่ง'],
        employeeId: '',
        chkLeaderApprove: false,
        leaderApprove: 'ไม่ต้องการ',
        chkEmployeeResign: false,
        EmployeeResign: 'ไม่ต้องการ',
        approver: [],
        orgchart: '',
        companyItems: this.companyItems
      })
      const self = this
      const obj = {
        keySearch: value
      }
      var tmpUserData = null
      // console.log(obj)
      try {
        const res = await searchSelectEmployee(obj, this.$store.state.token) // ข้อมูลพนักงาน
        if (res.success) {
          if (res.result.duplicate === true) {
            swal(
              'มีข้อมูลพนักงานคนนี้ในระบบแล้ว',
              'กรุณาตรวจสอบข้อมูลที่หน้าจัดการพนักงาน',
              'warning',
              {
                button: true
              }
            )
            this.keySearchEmployee = ''
          } else {
            swal('พบข้อมูล', 'กรุณาตรวจสอบข้อมูลพนักงาน', 'success', {
              button: false,
              timer: 3000
            })
            tmpUserData = res.result
            self.genderth_radios = tmpUserData.titleEn
            self.genderen_radios = tmpUserData.titleEn
            self.fnameTH = tmpUserData.firstNameTh
            self.lnameTH = tmpUserData.lastNameTh
            self.fnameEN = tmpUserData.firstNameEn
            self.lnameEN = tmpUserData.lastNameEn
            self.accountId = tmpUserData.accountId
            self.duplicate = tmpUserData.duplicate
            self.birthDate = moment(tmpUserData.birthday).format('DD/MM/YYYY')
            self.email = tmpUserData.emailOneId
            self.tel = tmpUserData.tel
            self.userImg = tmpUserData.userImg
            if (self.userImg === '') {
              self.imageUrl = `${hostImageUrlv3}/_/${tmpUserData.emailOneId}`
            } else {
              self.imageUrl = `${hostImageUrlv3}/${tmpUserData.userImg}/${tmpUserData.emailOneId}`
            }
            this.loading = false
          }
        } else {
          swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
            button: false,
            timer: 2000
          })
          tmpUserData = null
          self.genderth_radios = ''
          self.genderen_radios = ''
          self.fnameTH = ''
          self.lnameTH = ''
          self.fnameEN = ''
          self.lnameEN = ''
          self.accountId = ''
          self.birthDate = moment(
            new Date().toISOString().substr(0, 10)
          ).format('DD/MM/YYYY')
          self.email = ''
          this.loading = false
        }
      } catch (error) {
        // console.log(error)
        swal('ไม่พบข้อมูล', 'กรุณาตรวจสอบอีเมล One ID', 'warning', {
          button: false,
          timer: 3000
        })
        tmpUserData = null
        self.genderth_radios = ''
        self.genderen_radios = ''
        self.fnameTH = ''
        self.lnameTH = ''
        self.fnameEN = ''
        self.lnameEN = ''
        self.accountId = ''
        self.birthDate = moment(new Date().toISOString().substr(0, 10)).format(
          'DD/MM/YYYY'
        )
        self.email = ''
        this.loading = false
      }
    },
    openDialogAddPosition (companyId, indexI) {
      if (
        this.dataEmployee[indexI].companyId === '' ||
        this.dataEmployee[indexI].companyId === undefined
      ) {
        swal(
          'คำเตือน',
          'กรุณาเลือกบริษัทก่อนถึงจะสามารถเพิ่มตำแหน่งงานได้',
          'warning',
          {
            button: true
          }
        )
      } else {
        var nameCompany = ''
        this.dataEmployee[indexI].companyItems.map((data) => {
          if (companyId === data._id) {
            nameCompany = data.companyFullNameTh
          }
        })
        EventBus.$emit(
          'openDialogAddPosition',
          true,
          // this.dataEmployee[indexI].companyId,
          companyId,
          nameCompany,
          indexI
        )
      }
    },
    gotoProfile () {
      const self = this
      self.activeTab = 1
    },
    gotoWorkData () {
      const self = this
      if (self.activeTab === 1) {
        if (
          self.genderth_radios &&
          self.fnameTH &&
          self.lnameTH &&
          self.genderen_radios &&
          self.fnameEN &&
          self.lnameEN &&
          self.accountId &&
          self.birthDate &&
          self.email
        ) {
          if (self.imageUrl) {
            self.activeTab = 2
          } else {
            swal('คำเตือน', 'กรุณาเลือกรูปประจำตัว', 'warning', {
              button: false,
              timer: 3000
            })
          }
        } else {
          swal('คำเตือน', 'กรุณาระบุประวัติพนักงาน', 'warning', {
            button: false,
            timer: 3000
          })
        }
      } else {
        self.activeTab = 2
      }
    },
    gotoRecheck () {
      const self = this
      if (self.activeTab === 1) {
        self.gotoWorkData()
      } else if (self.activeTab === 2) {
        if (
          self.companyId &&
          self.employeeId &&
          self.lineofworkId &&
          self.departmentId &&
          self.positionId &&
          self.startWorkDate
        ) {
          self.activeTab = 3
        } else {
          swal('คำเตือน', 'กรุณาระบุข้อมูลพนักงาน', 'warning', {
            button: false,
            timer: 3000
          })
        }
      }
    },
    // get รายชื่อบริษัท
    async getSelectCompany (index, value) {
      this.loadingProfileData = true
      // this.dataEmployee[index].companyItems = [] // รายชื่อบริษัท
      var obj = {
        companyId: '',
        companyName: value,
        orgChartName: '',
        positionName: ''
      }
      try {
        const res = await getSelectCompanyEmployeeNew(obj, this.$store.state.token)
        if (res.success) {
          if (index === undefined) {
            this.companyItems = res.companys
            this.dataEmployee[0].companyItems = res.companys
          } else {
            this.dataEmployee[index].companyItems = res.companys
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loadingProfileData = false
      }
    },
    // ข้อมูลตัวเลือกศูนย์/รูปแบบพนักงาน
    async getCenterManageEmployee () {
      try {
        const res = await SelectDataCenterinEditOfficer()
        if (res.success) {
          this.stationList = res.selector.station
          this.employeeTypeList = res.selector.contractType
        }
      } catch (error) {
        console.log(error)
      }
    },
    // เลือกแผนกและตำแหน่ง
    async getSelectLineofworkDetail (i, cid) {
      // this.dataEmployee[i].departmentsItems = []
      // this.dataEmployee[i].positionItems = []
      const obj = {
        companyId: cid,
        companyName: '',
        orgChartName: '',
        positionName: ''
      }
      // this.loading = true
      try {
        const res = await getSelectCompanyEmployeeNew(obj, this.$store.state.token) // ใหม่
        if (res.success) {
          this.dataEmployee[i].companyItems = res.companys // บริษัท
          this.dataEmployee.splice(0, 0)
          this.dataEmployee[i].departmentsItems = res.orgchart // แผนก
          this.dataEmployee[i].positionItems = res.position // ตำแหน่ง
          this.loading = false
        }
      } catch (error) {
        console.log(error)
      }
    },
    // พิมพ์ค้นหาแผนกและตำแหน่ง
    async getSelect (value, keyname, i, companyId) {
      var datafilterall = ''
      if (keyname === 'แผนก') {
        const obj = {
          companyId: companyId,
          companyName: '',
          orgChartName: value,
          positionName: ''
        }
        datafilterall = obj
      } else if (keyname === 'ตำแหน่ง') {
        const obj = {
          companyId: companyId,
          companyName: '',
          orgChartName: '',
          positionName: value
        }
        datafilterall = obj
      }
      try {
        const res = await getSelectCompanyEmployeeNew(datafilterall, this.$store.state.token) // ใหม่
        if (res.success) {
          if (keyname === 'แผนก') {
            this.dataEmployee[i].departmentItems = res.orgchart // แผนก
            this.dataEmployee[i].positionItems = res.position // ตำแหน่ง
          } else if (keyname === 'ตำแหน่ง') {
            this.dataEmployee[i].positionItems = res.position // ตำแหน่ง
          }
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    // ฟังก์ชันข้อมูลตัวเลือกสายงานต่างๆ
    // async getSelectLineofwork (i, id) {
    //   console.log('i/id--', i, id)
    //   this.loading = true
    //   const self = this
    //   const obj = {
    //     companyId: id
    //   }
    //   self.dataEmployee[i].lineofworkDisable = false
    //   self.dataEmployee[i].departmentDisable = false
    //   self.dataEmployee[i].sectionDisable = false
    //   self.dataEmployee[i].groupDisable = false
    //   self.dataEmployee[i].agencyDisable = false
    //   self.dataEmployee[i].lineofworkId = 'ไม่มี'
    //   self.dataEmployee[i].departmentId = 'ไม่มี'
    //   self.dataEmployee[i].sectionId = 'ไม่มี'
    //   self.dataEmployee[i].groupId = 'ไม่มี'
    //   self.dataEmployee[i].agencyId = 'ไม่มี'
    //   self.dataEmployee[i].positionId = 'ไม่มี'
    //   self.dataEmployee[i].lineofworkItems = []
    //   self.dataEmployee[i].departmentsItems = []
    //   self.dataEmployee[i].sectionItems = []
    //   self.dataEmployee[i].groupItems = []
    //   self.dataEmployee[i].agencyItems = []
    //   self.dataEmployee[i].positionItems = []
    //   try {
    //     const res = await checkOrgChartInCompany(obj, self.$store.state.token)
    //     if (res.success) {
    //       // ตัวเลือกสายงาน
    //       self.dataEmployee[i].lineofworkItems =
    //         res.result.orgChart[0].list.length !== 0
    //           ? res.result.orgChart[0].list
    //           : self.itemDefault
    //       // ตัวเลือกฝ่ายงาน
    //       self.dataEmployee[i].departmentsItems =
    //         res.result.orgChart[1].list.length !== 0
    //           ? res.result.orgChart[1].list
    //           : self.itemDefault
    //       // เลือกส่วนงาน
    //       self.dataEmployee[i].sectionItems =
    //         res.result.orgChart[2].list.length !== 0
    //           ? res.result.orgChart[2].list
    //           : self.itemDefault
    //       // ตัวเลือกหน่วยงาน
    //       self.dataEmployee[i].agencyItems =
    //         res.result.orgChart[3].list.length !== 0
    //           ? res.result.orgChart[4].list
    //           : self.itemDefault
    //       // ตัวเลือกประเภท
    //       self.dataEmployee[i].groupItems =
    //         res.result.orgChart[4].list.length !== 0
    //           ? res.result.orgChart[3].list
    //           : self.itemDefault
    //       // ตัวเลือกตำแหน่ง
    //       self.dataEmployee[i].positionItems = res.result.position
    //       self.dataEmployee[i].lineofworkStatus = res.result.orgChart[0].status
    //       self.dataEmployee[i].departmentStatus = res.result.orgChart[1].status
    //       self.dataEmployee[i].sectionStatus = res.result.orgChart[2].status
    //       self.dataEmployee[i].groupStatus = res.result.orgChart[3].status
    //       self.dataEmployee[i].agencyStatus = res.result.orgChart[4].status
    //       self.dataEmployee[i].lineofworkDisable =
    //         res.result.orgChart[0].status
    //       self.dataEmployee[i].departmentDisable =
    //         res.result.orgChart[1].status
    //       self.dataEmployee[i].sectionDisable = res.result.orgChart[2].status
    //       self.dataEmployee[i].agencyDisable = res.result.orgChart[3].status
    //       self.dataEmployee[i].groupDisable = res.result.orgChart[4].status
    //       this.loading = false
    //     } else {
    //       swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
    //         button: false,
    //         timer: 2000
    //       })
    //       this.loading = false
    //     }
    //   } catch (error) {
    //     console.log(error)
    //     swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
    //       button: false,
    //       timer: 2000
    //     })
    //     this.loading = false
    //   }
    // },
    // async getDataListOrgChart (i, id, companyId, type) {
    //   console.log('idแผนก/idบริษัท/ประเภท :', id, companyId, type)
    //   this.loading = true
    //   const self = this
    //   var temp = []
    //   const obj = {
    //     _id: id,
    //     companyId: companyId
    //   }
    //   try {
    //     const res = await getListOrgChart(obj, self.$store.state.token)
    //     if (res.result.length === 0) {
    //       temp.unshift({
    //         _id: '',
    //         orgChartName: 'ไม่มี'
    //       })
    //     } else {
    //       temp = res.result
    //     }
    //     if (res.success) {
    //       if (type === 'สายงาน') {
    //         if (self.dataEmployee[i].lineofworkId !== '') {
    //           self.dataEmployee[i].departmentId = 'ไม่มี'
    //           self.dataEmployee[i].sectionId = 'ไม่มี'
    //           self.dataEmployee[i].groupId = 'ไม่มี'
    //           self.dataEmployee[i].agencyId = 'ไม่มี'
    //           self.dataEmployee[i].positionId = 'ไม่มี'
    //           self.dataEmployee[i].departmentsItems = self.itemDefault
    //           self.dataEmployee[i].sectionItems = self.itemDefault
    //           self.dataEmployee[i].groupItems = self.itemDefault
    //           self.dataEmployee[i].agencyItems = self.itemDefault
    //           self.dataEmployee[i].departmentStatus = false
    //           self.dataEmployee[i].sectionStatus = false
    //           self.dataEmployee[i].groupStatus = false
    //           self.dataEmployee[i].agencyStatus = false
    //           if (self.dataEmployee[i].lineofworkStatus === true) {
    //             if (res.result.length === 0) {
    //               self.dataEmployee[i].departmentsItems = [
    //                 {
    //                   _id: 'ไม่มี',
    //                   orgChartName: 'ไม่มี'
    //                 }
    //               ]
    //               self.dataEmployee[i].departmentId = 'ไม่มี'
    //             } else {
    //               self.dataEmployee[i].departmentsItems = res.result
    //               self.dataEmployee[i].departmentsItems.unshift({
    //                 _id: 'ไม่มี',
    //                 orgChartName: 'ไม่มี'
    //               })
    //             }
    //             self.dataEmployee[i].departmentDisable = true
    //             self.dataEmployee[i].departmentStatus = true
    //           } else {
    //             self.dataEmployee[i].departmentDisable = false
    //             self.dataEmployee[i].departmentStatus = false
    //           }
    //         }
    //       } else if (type === 'ฝ่ายงาน') {
    //         if (self.dataEmployee[i].departmentId !== '') {
    //           self.dataEmployee[i].sectionId = 'ไม่มี'
    //           self.dataEmployee[i].groupId = 'ไม่มี'
    //           self.dataEmployee[i].agencyId = 'ไม่มี'
    //           self.dataEmployee[i].sectionItems = self.itemDefault
    //           self.dataEmployee[i].groupItems = self.itemDefault
    //           self.dataEmployee[i].agencyItems = self.itemDefault
    //           self.dataEmployee[i].sectionStatus = false
    //           self.dataEmployee[i].groupStatus = false
    //           self.dataEmployee[i].agencyStatus = false
    //           console.log('length', res.result.length)
    //           if (self.dataEmployee[i].departmentStatus === true) {
    //             if (res.result.length === 0) {
    //               self.dataEmployee[i].sectionItems = [
    //                 {
    //                   _id: 'ไม่มี',
    //                   orgChartName: 'ไม่มี'
    //                 }
    //               ]
    //               self.dataEmployee[i].sectionId = 'ไม่มี'
    //             } else {
    //               self.dataEmployee[i].sectionItems = res.result
    //               self.dataEmployee[i].sectionItems.unshift({
    //                 _id: 'ไม่มี',
    //                 orgChartName: 'ไม่มี'
    //               })
    //             }
    //             self.dataEmployee[i].sectionDisable = true
    //             self.dataEmployee[i].sectionStatus = true
    //           } else {
    //             self.dataEmployee[i].sectionDisable = false
    //             self.dataEmployee[i].sectionStatus = false
    //           }
    //         }
    //       } else if (type === 'ส่วนงาน') {
    //         if (self.dataEmployee[i].sectionId !== '') {
    //           self.dataEmployee[i].agencyId = 'ไม่มี'
    //           self.dataEmployee[i].groupId = 'ไม่มี'
    //           self.dataEmployee[i].agencyItems = self.itemDefault
    //           self.dataEmployee[i].groupItems = self.itemDefault
    //           self.dataEmployee[i].agencyStatus = false
    //           self.dataEmployee[i].groupStatus = false
    //           if (self.dataEmployee[i].sectionStatus === true) {
    //             if (res.result.length === 0) {
    //               self.dataEmployee[i].agencyItems = [
    //                 {
    //                   _id: 'ไม่มี',
    //                   orgChartName: 'ไม่มี'
    //                 }
    //               ]
    //               self.dataEmployee[i].agencyId = 'ไม่มี'
    //             } else {
    //               self.dataEmployee[i].agencyItems = res.result
    //               self.dataEmployee[i].agencyItems.unshift({
    //                 _id: 'ไม่มี',
    //                 orgChartName: 'ไม่มี'
    //               })
    //             }
    //             self.dataEmployee[i].agencyDisable = true
    //             self.dataEmployee[i].agencyStatus = true
    //           } else {
    //             self.dataEmployee[i].agencyDisable = false
    //             self.dataEmployee[i].agencyStatus = false
    //           }
    //         }
    //       } else if (type === 'หน่วยงาน') {
    //         if (self.dataEmployee[i].agencyId !== '') {
    //           self.dataEmployee[i].groupId = 'ไม่มี'
    //           self.dataEmployee[i].groupItems = self.itemDefault
    //           self.dataEmployee[i].groupStatus = false
    //           if (self.dataEmployee[i].agencyStatus === true) {
    //             if (res.result.length === 0) {
    //               self.dataEmployee[i].groupItems = [
    //                 {
    //                   _id: 'ไม่มี',
    //                   orgChartName: 'ไม่มี'
    //                 }
    //               ]
    //               self.dataEmployee[i].groupId = 'ไม่มี'
    //             } else {
    //               self.dataEmployee[i].groupItems = res.result
    //               self.dataEmployee[i].groupItems.unshift({
    //                 _id: 'ไม่มี',
    //                 orgChartName: 'ไม่มี'
    //               })
    //             }
    //             self.dataEmployee[i].groupDisable = true
    //             self.dataEmployee[i].groupStatus = true
    //           } else {
    //             self.dataEmployee[i].groupDisable = false
    //             self.dataEmployee[i].groupStatus = false
    //           }
    //         }
    //       } else if (type === 'กลุ่มงาน') {
    //         if (self.dataEmployee[i].gruopId !== '') {
    //           if (self.dataEmployee[i].groupStatus === true) {
    //             self.dataEmployee[i].positionDisable = true
    //             self.dataEmployee[i].positionStatus = true
    //           }
    //         }
    //       }
    //       this.loading = false
    //     } else {
    //       swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
    //         button: false,
    //         timer: 2000
    //       })
    //       this.loading = false
    //     }
    //   } catch (error) {
    //     console.log(error)
    //     swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
    //       button: false,
    //       timer: 2000
    //     })
    //     this.loading = false
    //   }
    // },
    ChooseBanner () {
      this.$refs.Pickfiles.click()
    },
    onBannerSelected () {
      this.files = []
      var uploadedImage = this.$refs.Pickfiles.files
      var dotindex = uploadedImage[0].name.lastIndexOf('.')
      var FileExtension = uploadedImage[0].name
        .substr(dotindex + 1)
        .toLowerCase()
      if (
        FileExtension === 'jpg' ||
        FileExtension === 'png' ||
        FileExtension === 'JPG' ||
        FileExtension === 'PNG'
      ) {
        if (!uploadedImage[0]) return
        const reader = new FileReader()
        reader.readAsDataURL(uploadedImage[0])
        reader.onload = evt => {
          var imgUser = new Image()
          this.files.push(uploadedImage[0])
          // console.log(this.files[0])
          const fr = new FileReader()
          fr.readAsDataURL(this.files[0])
          fr.addEventListener('load', () => {
            this.nameimg = this.files[0].name
            this.imageUrl = fr.result
          })
          imgUser.src = evt.target.result
        }
      }
    },
    async setApprover (i, departmentId) {
      this.loading = true
      this.selectData = []
      const obj = {
        orgChartId: departmentId
      }
      try {
        const res = await getDefaultApprover(obj, this.$store.state.token)
        if (res.success) {
          if (res.result.length) {
            var imageUrlDefault = ''
            if (res.result[0].userImg === '') {
              imageUrlDefault = `${hostImageUrlv3}/_/${res.result[0].emailOneId}`
            } else {
              imageUrlDefault = `${hostImageUrlv3}/${res.result[0].userImg}/${res.result[0].emailOneId}`
            }
            this.dataEmployee[i].approver = [
              {
                no: 1,
                _id: res.result[0]._id,
                employeeId: res.result[0].employeeId,
                approverName: res.result[0].approverName,
                position: res.result[0].position,
                email: res.result[0].email,
                approveType: 'ผู้อนุมัติ',
                userImg: imageUrlDefault
              }
            ]
          }
          // console.log(res)
        } else {
          // console.log(res)
        }
      } catch (error) {
        // alert(error)
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    openDialogAddAprover (action, item, index, indexJ) {
      EventBus.$emit('openDialogAddAprover', true, item, action, index, indexJ)
    },
    // เพิ่มข้อมูลพนักงานชุดใหม่
    addEmployee () {
      this.dataEmployee.push({
        employeeType: '',
        parentCompanyText: 'บริษัทรอง',
        leaderApprove: 'ไม่ต้องการ',
        startWorkDate: new Date().toISOString().substr(0, 10),
        endWorkDate: '',
        contractType: '',
        station: '',
        lineofworkItems: [],
        departmentStatus: false,
        departmentDisable: false,
        departmentId: '',
        departmentsItems: [],
        sectionStatus: false,
        sectionDisable: false,
        sectionId: '',
        sectionItems: [],
        groupStatus: false,
        groupDisable: false,
        groupId: '',
        groupItems: [],
        agencyStatus: false,
        agencyDisable: false,
        agencyId: '',
        agencyItems: [],
        positionStatus: false,
        positionDisable: true,
        positionId: '',
        positionItems: [],
        approver: [],
        orgchart: '',
        companyItems: this.companyItems
      })
      this.text = 'เพิ่มข้อมูลพนักงาน'
      this.snackbarColor = 'success'
      this.snackbar = true
    },
    addPosition (item, indexI) {
      var temp = JSON.parse(JSON.stringify(this.dataEmployee))
      temp[indexI].positionItems.unshift({
        _id: item[0]._id,
        positionName: item[0].positionName
      })
      this.dataEmployee = JSON.parse(JSON.stringify(temp))
    },
    // เพิ่มผู้อนุมัติ
    add (value, index, action, indexJ) {
      var filterValue = this.dataEmployee[index].approver.filter(r => {
        // if (
        //   r.position === value.position &&
        //   r.employeeId === value.employeeId
        // ) {
        if (
          r.emailOneId === value.email &&
          r.employeeId === value.employeeId
        ) {
          return r
        }
      })
      if (action === 'add') {
        if (filterValue.length > 0) {
          swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
        } else {
          this.dataEmployee[index].approver.push({
            approverNo: this.dataEmployee[index].approver.length + 1,
            _id: value.id,
            employeeId: value.employeeId,
            employee_id: value.employee_id,
            approverName: value.name,
            // position: value.position,
            email: value.email,
            userImg: value.userImg,
            approveType: value.approveType,
            failed_image: false
          })
        }
      } else if (action === 'edit') {
        if (filterValue.length > 0) {
          swal('คำเตือน', 'คุณได้เพิ่มพนักงานคนนี้แล้ว', 'warning')
        } else {
          this.dataEmployee[index].approver[indexJ].approverNo = index + 1
          this.dataEmployee[index].approver[indexJ]._id = value.id
          this.dataEmployee[index].approver[indexJ].employeeId =
            value.employeeId
          this.dataEmployee[index].approver[indexJ].employee_id = value.employee_id
          this.dataEmployee[index].approver[indexJ].approverName = value.name
          // this.dataEmployee[index].approver[indexJ].position = value.positionId
          this.dataEmployee[index].approver[indexJ].email = value.email
          this.dataEmployee[index].approver[indexJ].approveType =
            value.approveType
          this.dataEmployee[index].approver[indexJ].userImg = value.userImg
          this.dataEmployee[index].approver[indexJ].failed_image =
            value.failed_image || false
        }
      }
    },
    remove (index) {
      this.positionData.splice(index, 1)
    },
    // ลบผู้ดูแลอนุมัติ
    checkRemove (item, index) {
      this.itemConfirmDelete = []
      this.itemIndex = 0
      this.itemConfirmDelete = item
      this.itemIndex = index
      this.dialogDeleteApprover = true
    },
    // ยืนยันลบข้อมูลผู้อนุมัติ
    removeApprover (item, index) {
      this.dataEmployee[index].approver.splice(
        this.dataEmployee[index].approver.indexOf(item),
        1
      )
      this.itemConfirmDelete = []
      this.itemIndex = 0
      this.dialogDeleteApprover = false
      this.text = 'คุณได้ทำการลบข้อมูลผู้อนุมัติเรียบร้อยแล้ว'
      this.snackbar = true
    },
    // ยังไม่ได้ใช้
    openDialogCheckConfirm (item, actionTitle) {
      this.titleDialog = actionTitle
      this.dialogDelete = true
    },
    // ลบชุดข้อมูลพนักงาน
    checkRemoveEmployee (item) {
      this.itemConfirmDelete = []
      this.itemConfirmDelete = item
      this.dialogDelete = true
    },
    // ยืนยันการลบชุดข้อมูลพนักงาน
    removeEmployee (item) {
      this.dataEmployee.splice(this.dataEmployee.indexOf(item), 1)
      this.itemConfirmDelete = []
      this.dialogDelete = false
      this.text = 'คุณได้ทำการลบข้อมูลเรียบร้อยแล้ว'
      this.snackbarColor = 'success'
      this.snackbar = true
    },
    // เช็คการกรอกข้อมูลก่อนบันทึกข้อมูลพนักงาน
    checkSubmit () {
      var checkValue = this.dataEmployee.filter((r, index) => {
        var valueIndex = index + 1
        if (r.employeeType === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณากรอกเลือกประเภทพนักงาน',
            'warning'
          )
          return r
        }
        if (r.typeText === 'พนักงานภายใน' && r.employeeId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณากรอกรหัสพนักงาน',
            'warning'
          )
          return r
        }
        if (r.typeText === 'พนักงานภายนอก' && r.employeeId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณากรอกรหัสพนักงาน',
            'warning'
          )
          return r
        }
        if (r.typeText === 'ที่ปรึกษา' && r.employeeId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณากรอกรหัสพนักงาน',
            'warning'
          )
          return r
        }
        if (r.typeText === 'นักศึกษาฝึกงาน' && r.employeeId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณากรอกรหัสพนักงาน',
            'warning'
          )
          return r
        }
        if (r.companyId === '') {
          // console.log('null')
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณาเลือกบริษัท',
            'warning'
          )
          return r
        }
        if (r.employeeId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณากรอกรหัสพนักงาน',
            'warning'
          )
          return r
        }
        if (r.lineofworkStatus === true && r.lineofworkId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณาเลือกสายงาน',
            'warning'
          )
          return r
        }
        if (r.orgchart === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณาเลือกแผนก',
            'warning'
          )
          return r
        }
        if (r.departmentStatus === true && r.departmentId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณาเลือกฝ่ายงาน',
            'warning'
          )
          return r
        }
        if (r.sectionStatus === true && r.sectionId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณาเลือกส่วนงาน',
            'warning'
          )
          return r
        }
        if (r.agencyStatus === true && r.agencyId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณาเลือกหน่วยงาน',
            'warning'
          )
          return r
        }
        if (r.groupStatus === true && r.groupId === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณาเลือกกลุ่มงาน',
            'warning'
          )
          return r
        }
        if (r.positionId === '' || r.positionId === 'ไม่มี') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' + valueIndex + ' กรุณาเลือกตำแหน่งงาน',
            'warning'
          )
          return r
        }
        if (r.resign === true && r.endWorkDate === '') {
          swal(
            'คำเตือน',
            'ข้อมูลลำดับที่ ' +
              valueIndex +
              ' กรุณาเลือกวันลาออกมีผลบังคับใช้เมื่อ',
            'warning'
          )
          return r
        }
      })
      if (checkValue.length === 0) {
        this.submitData()
      }
    },
    // บันทึกการเพิ่มพนักงาน
    async submitData () {
      this.loading = true
      this.loadingEmployeeData = true
      var checkValue = this.dataEmployee.filter(r => {
        if (r.positionId === '') {
          return r
        } else {
        }
      })
      if (checkValue.length > 0) {
        swal('คำเตือน', 'กรุณาเลือกตำแหน่ง', 'warning', {
          buttons: false,
          timer: 3000
        })
        this.loading = false
      }
      var formData = new FormData()
      formData.append('username', this.email)
      formData.append('dataEmployee', JSON.stringify(this.dataEmployee))
      formData.append('image', '')
      if (this?.files?.length) formData.append('image', this.files[0])
      else if (this.imagePathUrl) formData.append('image', '')
      const obj = formData
      try {
        const res = await insertEmployee(obj, this.$store.state.token)
        if (res.success) {
          this.loading = false
          // this.text = 'คุณได้ทำการเพิ่มข้อมูลเรียบร้อยแล้ว'
          // this.snackbarColor = 'success'
          // this.snackbar = true
          swal(
            'สำเร็จ',
            'คุณได้ทำการเพิ่มข้อมูลพนักงานเรียบร้อยแล้ว',
            'success',
            {
              button: false,
              timer: 2000
            }
          )
          this.files = []
          this.loadingEmployeeData = false
          this.$router.go(-1)
        } else {
          swal(
            'ผิดพลาด',
            `${this.alertText[res.data.msg] || ''} กรุณาลองใหม่อีกครั้ง`,
            'error'
          )
          this.loading = false
        }
      } catch (error) {
        swal('ผิดพลาด', 'กรุณาลองใหม่อีกครั้ง', 'error', {
          button: false,
          timer: 2000
        })
        this.loading = false
      } finally {
        this.loadingEmployeeData = false
      }
    },
    onImgError (i, j) {
      this.dataEmployee[i].approver[j].failed_image = true
    },
    onImgErrorEmployee (i) {
      // this.approver[i].failed_image = true
    },
    cancel () {
      this.$router.go(-1)
    },
    goback () {
      swal('คำเตือน', 'ข้อมูลของพนักงานจะถูกรีเซ็ต', 'warning', {
        dangerMode: true,
        buttons: true
      }).then(willDelete => {
        if (willDelete) {
          swal('คำเตือน', 'ข้อมูลของพนักงานถูกรีเซ็ตเรียบร้อยแล้ว', 'warning', {
            buttons: false,
            timer: 3000
          }).then(() => this.$router.go(-1))
        } else {
          swal('คำเตือน', 'ข้อมูลของพนักงานยังไม่ถูกรีเซ็ต', 'warning', {
            buttons: false,
            timer: 3000
          })
        }
      })
    },
    goLogin () {
      this.loading = true
      setTimeout(() => {
        this.$store.commit('clearToken')
        this.$store.commit('clearUser')
        this.loading = false
        this.$router.push('/login')
      }, 2000)
    }
  }
}
</script>

<style scoped>
@import "../../../css/CreateEmployee.css";

.v-stepper {
  box-shadow: none !important;
}
.v-stepper__header {
  box-shadow: none !important;
}
.v-application {
  padding: 0 !important;
}
.maminus-5 {
  margin: 0 -20px !important;
}
.v-stepper__step {
  flex-direction: column !important;
}
.v-application--is-ltr .v-stepper__step__step {
  margin-right: 0 !important;
}
.theme--light.v-divider {
  border-color: rgb(229, 230, 231) !important;
}
.step-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: fit-content;
  padding: 24px;
  position: relative;
}
.step-container:hover {
  cursor: pointer;
}
.step-container:hover .step-circle-inactive {
  /* border: 2px solid rgb(122, 212, 108) !important; */
  border: 2px solid #004682 !important;
}
.step-container:hover .step-circle-text-inactive {
  /* color:rgb(122, 212, 108) !important; */
  color: #004682 !important;
}
.step-container:hover .step-text-inactive {
  /* color:rgb(122, 212, 108) !important; */
  color: #004682 !important;
}
.step-circle-active {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  font-size: 0.75rem;
  justify-content: center;
  height: 24px;
  min-width: 24px;
  width: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: transparent !important;
  /* border: 2px solid rgb(103, 173, 92) !important; */
  border: 2px solid #07d1bf !important;
}
.step-circle-text-active {
  font-weight: 600;
  /* color: rgb(103, 173, 92) !important; */
  color: #07d1bf !important;
}
.step-text-active {
  font-weight: 600;
  /* color: rgb(103, 173, 92) !important; */
  color: #07d1bf !important;
}
.step-circle-inactive {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  font-size: 0.75rem;
  justify-content: center;
  height: 24px;
  min-width: 24px;
  width: 24px;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  background-color: transparent !important;
  border: 2px solid rgb(229, 230, 231) !important;
}
.step-circle-text-inactive {
  font-weight: 600;
  color: rgb(229, 230, 231) !important;
}
.step-text-inactive {
  font-weight: 600;
  color: rgb(229, 230, 231) !important;
}
.container-profile {
  border-radius: 15px;
  border: 1px solid rgb(229, 230, 231);
  background-color: #fff;
}
div.v-input--selection-controls {
  margin-top: 0 !important;
  padding-top: 0 !important;
}
div.v-messages {
  min-height: 0 !important;
}
.txt-font {
  /* font-family: 'Sarabun', sans-serif;
  font-weight: normal;
  font-size: 18px; */
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 5px;
  color: #757575;
}
.ra-span-text-highlight {
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Neutral / #333333 */

  color: #333333;
}
.ra-layout-empty {
  height: 640px;
  left: 32px;
  right: 32px;
  top: 164px;
}
.ra-head-text-bold {
  font-family: "Sarabun", sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  /* identical to box height, or 150% */

  display: flex;
  align-items: center;

  /* Color / Primary / Hover */

  color: #2BA197;
}
.radio-border {
  height: 45px;
  border: 2px solid #ddd;
  border-radius: 5px;
  padding: 15px;
}
.ra-snackbar {
  background-color: chocolate;
}
.ra-text-in-button-employee {
  font-family: "Sarabun", sans-serif;
  /* font-weight: normal; */
  font-style: normal;
  font-weight: 200;
  font-size: 14px;
}
</style>
